import { FormikProps, FormikValues } from "formik"

const getFieldsErrorsAsString = (fieldErrors: any): string => {
    try {
        if (Array.isArray(fieldErrors)) {
            let errMessages = []

            fieldErrors.forEach((value) => {
                if (typeof value === 'object') {
                    errMessages.push(value[Object.keys(value)[0]])
                } else {
                    errMessages.push(value)
                }
            })

            return errMessages.join('<br />')
        } else if (typeof fieldErrors === 'string') {
            return fieldErrors
        } else {
            return 'Invalid data'
        }
    } catch (error) {
        return error.message
    }
}

export const handleAxiosErrors = (
    error,
    setErrMsg,
    setErrorFields = undefined,
    config = undefined
): void => {
    if (!error?.response) {
        setErrMsg('No Server Response')
    } else if (error.response?.status === 400) {
        if (setErrorFields) setErrorFields(error.response.data.errors[0])
        setErrMsg(getFieldsErrorsAsString(error.response.data.errors))
    } else {
        try {
            const errorMsg = error.response.data.errors[0]
            if (setErrorFields)
                setErrorFields(
                    typeof errorMsg === 'object' ? errorMsg : { errorMsg }
                )
            setErrMsg(errorMsg)
        } catch (e) {
            setErrMsg(config?.submitFailedMsg?.message || 'Failed to process')
        }
    }
}

export const buildFormikErrorsIbject = (formikProps: FormikProps<FormikValues>) => {
    let formattedErrorsObject = {}

    const errors = Object.entries(formikProps.errors)

    for (const [fieldName, error] of errors) {
        if (formikProps.touched[fieldName])
            formattedErrorsObject[fieldName] = error.toString()
    }

    return formattedErrorsObject
}